import React, { useState } from "react"
import { Formik, Form, Field } from "formik"
import * as Yup from "yup"
import Button from "../botonFormulario"
import { HeroWrapper } from "./style"
import { navigate } from "gatsby"

const HeroAlquiler = ({ img, title, text }) => {
  let [nospam, setNospam] = useState("")
  const requiredText = "Es requerido este campo"

  const ValidationYup = Yup.object().shape({
    name: Yup.string()
      .min(3, "Tiene que tener al menos 3 letras")
      .required(requiredText),
    email: Yup.string()
      .email("Dirección de correo electrónico inválida")
      .required(requiredText),
    telefono: Yup.string()
      .required(requiredText)
      .matches(/^[0-9]+$/, "Tiene que ser solo digitos")
      .min(9, "Tiene que ser de 9 digitos")
      .max(9, "Tiene que ser de 9 digitos"),
    mensaje: Yup.string().required(requiredText),
    condiciones: Yup.boolean().oneOf(
      [true],
      "Tienes que aceptar las Politica de Privacidad"
    ),
  })

  const handleSubmit = values => {
    let data = new FormData()
    let apiUrl = `https://intramet.com.pe/server/trabajaContacto.php`
    data.append("email", values.email)
    data.append("mensaje", values.mensaje)
    data.append("name", values.name)
    data.append("telefono", values.telefono)

    if (nospam === "") {
      fetch(apiUrl, {
        method: "POST",
        body: data,
      })
        .then(response => response.json())
        .catch(error => console.log(error))
    }
    navigate("/gracias/")
  }

  return (
    <HeroWrapper img={img}>
      <div className="hero__overlay container">
        <div className="hero__info" data-aos="fade-right" data-aos-duration="1000">
          <h1>{title}</h1>
          <p>{text}</p>
        </div>
        <div className="hero__formWrapper" data-aos="fade-left" data-aos-duration="1200">
          <div className="cabecera">
            <h3>Solicita tu cotizaci&oacute;n</h3>
            <p>Estamos listos para brindarte la mejor asesor&iacute;a.</p>
          </div>
          <Formik
            initialValues={{
              name: "",
              email: "",
              telefono: "",
              mensaje: "",
              condiciones: false,
            }}
            validationSchema={ValidationYup}
            onSubmit={handleSubmit}
          >
            {({ errors, touched }) => (
              <Form>
                <label htmlFor="name">Nombres y Apellidos *</label>
                <Field type="text" name="name" />
                {touched.name && errors.name ? (
                  <div className="errorForm">{errors.name}</div>
                ) : null}
                <label htmlFor="telefono">Celular *</label>
                <Field name="telefono" type="text" />
                {touched.telefono && errors.telefono ? (
                  <div className="errorForm">{errors.telefono}</div>
                ) : null}
                <label htmlFor="email">Email *</label>
                <Field name="email" type="email" />
                {touched.email && errors.email ? (
                  <div className="errorForm">{errors.email}</div>
                ) : null}
                <label htmlFor="mensaje">Mensaje *</label>
                <Field
                  component="textarea"
                  name="mensaje"
                  id="mensaje"
                  cols="30"
                  rows="5"
                />
                {touched.mensaje && errors.mensaje ? (
                  <div className="errorForm">{errors.mensaje}</div>
                ) : null}
                <label className="condiciones">
                  <Field type="checkbox" name="condiciones" id="condiciones" />
                  <span>
                    Al enviar acepto las
                    <a
                      href="/politica-privacidad"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}<b>pol&iacute;ticas de privacidad</b>{" "}
                    </a>
                    de Intramet
                  </span>
                </label>
                {touched.condiciones && errors.condiciones ? (
                  <div className="errorForm">{errors.condiciones}</div>
                ) : null}
                <div style={{ display: "none" }}>
                  <label htmlFor="nospam">Campo de control</label>
                  <input
                    type="text"
                    name="nospam"
                    onChange={e => setNospam(e.target.value)}
                  />
                </div>
                <div className="buttons">
                  <button type="submit" className="btn-light-alt">Solicitar cotización</button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </HeroWrapper>
  )
}

export default HeroAlquiler
